<template>
  <div ref="ellipsis" :data-filename="fileName" class="ellipsis">
    <span ref="startEllipsis"></span>
    <span ref="endEllipsis" class="endEllipsis"></span>
  </div>
</template>
<script setup lang="ts">
  import { useFormatTransmissionFilename } from '@/core/compositions/FormatText'
  import { delay } from 'lodash'
  import { onMounted, ref } from 'vue'

  defineProps<{ fileName: string }>()

  const ellipsis = ref<HTMLDivElement | null>(null)
  const startEllipsis = ref<HTMLSpanElement | null>(null)
  const endEllipsis = ref<HTMLSpanElement | null>(null)

  onMounted(() => {
    // 这里需要获取dom元素的真实宽高，nextTick 等无法保证，故加入延时获取插入宏任务队列，等待渲染微任务完全执行完后，执行拿取真实宽高
    delay(() => {
      if (ellipsis.value && startEllipsis.value && endEllipsis.value) {
        useFormatTransmissionFilename(ellipsis.value, startEllipsis.value, endEllipsis.value)
      }
    }, 0)
  })
</script>
<style scoped lang="stylus">

  .ellipsis
    rect(100%)
    white-space nowrap
    line-height 40px
    display flex
    span
      max-width 100%
    .endEllipsis
      text-align right

  @import '../styles/h5Adaptive/Transmission.styl'
</style>
